module.exports = __webpack_public_path__ + "img/Demo-Skript-Icon_centered_02.2d05197a.png";